module.exports = __webpack_public_path__ + "img/emptyDash.96bdec61.svg";